import HttpService from './HttpService';

export default class StatsService extends HttpService {
    endPoint = "/v1/stats"

    paymentMethodStat({businessIdentifier, isLive, currencyCode, balanceMode}) {
        return new HttpService().getAuthTokenRequest()
            .get("/v1/stats/payment-method-stat", {
                params: {
                    businessIdentifier: businessIdentifier,
                    isLive: isLive,
                    currencyCode: currencyCode,
                    balanceMode: balanceMode
                }
            });
    }

    paymentByCurrencyStat({businessIdentifier, isLive, currencyCode, balanceMode}) {
        return new HttpService().getAuthTokenRequest()
            .get("/v1/stats/currency-stat", {
                params: {
                    businessIdentifier: businessIdentifier,
                    isLive: isLive,
                    currencyCode: currencyCode,
                    balanceMode: balanceMode
                }
            });
    }

}
